const DEFAULT_TITLE = "เกิดข้อผิดพลาด";
const FALLBACK_MESSAGE =
    "เกิดข้อผิดพลาดกรุณาติดต่อผู้ดูแลระบบ | Something went wrong, Please contact Administrator";

/**
 * Turns whatever was thrown into something showable.
 *
 * NMU-453: this has to cope with anything, because callers throw anything. Two
 * holes were reachable from the Programs page:
 *
 *  - `undefined` fell to the last branch and logged "unknow error undefined",
 *    which told nobody anything about where it came from;
 *  - `null` took the object branch, because `typeof null === "object"`, and then
 *    threw a TypeError of its own reading `.title` — an error handler that
 *    errors, replacing the real failure with a confusing one.
 *
 * The thrower is fixed separately (program-service assertSuccess); this makes
 * the handler safe whatever reaches it, so a future one degrades to a readable
 * message instead of breaking the click.
 */
const getMessage = (error) => {
    const errorMsg = { title: DEFAULT_TITLE, message: null };

    if (typeof error === "string" && error.trim()) {
        errorMsg.message = error;
        return errorMsg;
    }

    // Guards against null, which is also typeof "object".
    if (error && typeof error === "object") {
        errorMsg.title = error.title || DEFAULT_TITLE;
        errorMsg.message = error.responseMsgTh || error.responseMsgEn || error.message || FALLBACK_MESSAGE;
        errorMsg.code = error.code;
        return errorMsg;
    }

    // null / undefined / empty string / anything else: still show something
    // useful, and leave a breadcrumb that says which value arrived.
    console.warn("[error-msg-handler] nothing usable was thrown:", error);
    errorMsg.message = FALLBACK_MESSAGE;
    return errorMsg;
};

const errorMessageHandler = {
    getMessage
}

export default errorMessageHandler;
